<template>
  <div class="bar-chart-container pt-5 pr-5">
    <Bar
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :width="width"
      :height="height"
    />
  </div>
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
  name: "BarChart",
  components: { Bar },
  props: {
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chartData: {
        labels: ["January", "February", "March", "April", "May", "June", "July"],
        datasets: [
          {
            label: "Pass",
            backgroundColor: "#8CE2A9",
            data: [40, 20, 12, 39, 10, 0, 0].map(v => (v === 0 ? null : v)),
          },
          {
            label: "Fail",
            backgroundColor: "#F7C3BB",
            data: [20, 20, 12, 39, 10, 0, 0].map(v => (v === 0 ? null : v)),
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom",
          },
        },
        scales: {
          x: {
            stacked: true,
            grid: { display: false },
          },
          y: {
            stacked: true,
            grid: { display: false },
            beginAtZero: true,
            // ticks: {
            //   stepSize: 10,
            // },
          },
        },
      },
    };
  },
  mounted() {
    // 🔹 Dynamically calculate max total for Y-axis
    const passData = this.chartData.datasets[0].data.map(v => v || 0);
    const failData = this.chartData.datasets[1].data.map(v => v || 0);
    const totals = passData.map((v, i) => v + failData[i]);

    const maxTotal = Math.max(...totals);
    const suggestedMax = Math.ceil((maxTotal + 10) / 10) * 10; // round to nearest 10

    this.chartOptions.scales.y.max = suggestedMax;
  },
};
</script>

<style scoped>
.bar-chart-container {
  width: 100%;
  height: 100%;
  max-width: 100%;
  margin: auto;
  position: relative;
}
.bar-chart-container canvas {
  height: 280px !important;
}
</style>
